module.exports = __webpack_public_path__ + "img/vertical_6_5_0.e03c1628.png";